
























































































































































































































































































































  

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import DateTimeUtils from '@/lib/dateTimeUtils';
import CreateJobWorkerInterviewRequest from '@/models/JobWorkerInterviews/CreateJobWorkerInterviewRequest'
import ContactLocationDto from '@/models/ContactLocations/ContactLocationDto';
import ajax from '@/lib/ajax';
import JobWorkerDto from '@/models/JobWorkers/JobWorkerDto';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import { AppModule } from '@/store/modules/app';
import CreateJobWorkerInterviewViewModel from '@/models/JobWorkerInterviews/CreateJobWorkerInterviewViewModel';
import ListUtils from '@/lib/listUtils';
import InPersonInterviewAddressType from '@/models/JobWorkerInterviews/InPersonInterviewAddressType';
import JobWorkerInterviewType from '@/models/JobWorkerInterviews/JobWorkerInterviewType';
import CompanyAddressDto from '@/models/CompanyAddresses/CompanyAddressDto';
import LocationDto from '@/models/Locations/LocationDto';
import AddressUtils from '@/lib/addressUtils';
import CountryIso from '@/lib/countryIso';
import JobWorkerStatus from '@/models/JobWorkers/JobWorkerStatus';

@Component({
    name: 'JobWorkerInterviewCreate'
})
export default class extends GiganautVueDialog {
 
    jobWorkerInterviewType = JobWorkerInterviewType;
    inPersonInterviewAddressType = InPersonInterviewAddressType;

    @Prop({required: true})
    jobWorker: JobWorkerDto;
    contactLocations: ContactLocationDto[] = [];
    companyAddresses: CompanyAddressDto[] = [];
    locations: LocationDto[] = [];
    vm: CreateJobWorkerInterviewViewModel = new CreateJobWorkerInterviewViewModel();
    request: CreateJobWorkerInterviewRequest;

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.vm = new CreateJobWorkerInterviewViewModel();
            this.vm.jobWorkerId = this.jobWorker.id;
            await ajax.get(`/api/v1/agency/locations/${JobDetailsModule.currentJob.locationId}/contacts`)
            .then(response => {
                this.contactLocations = response.data;
            })
            .catch(error => {
                AppModule.handleApiError(error);
            })
            //Pick out the current job contact as the default
            this.vm.selectedContactLocation = this.contactLocations.find((contactLocationToFind: ContactLocationDto) => contactLocationToFind.contactId === JobDetailsModule.currentJob.contactId);
            await ajax.get(`/api/v1/agency/companies/${JobDetailsModule.currentJob.companyId}/addresses`)
            .then(response => {
                this.companyAddresses = response.data;
            })
            .catch(error => {
                AppModule.handleApiError(error);
            })
            await ajax.get(`/api/v1/agency/companies/${JobDetailsModule.currentJob.companyId}/locations`)
            .then(response => {
                this.locations = response.data;
            })
            .catch(error => {
                AppModule.handleApiError(error);
            })
        }
    }

    get disabled() {
		if (this.jobWorker.status === JobWorkerStatus.InterviewOne || this.jobWorker.status === JobWorkerStatus.InterviewTwo) {
            return false;
        }
        return true;
	}

    get loading() {
        return JobDetailsModule.loadingDialog;
    }

    get interviewTypeOptions() {
        return ListUtils.jobWorkerInterviewTypeOptions();
    }

    get inPersonInterviewAddressTypeOptions() {
        return ListUtils.inPersonInterviewAddressTypeOptions();
    }

    get isoCountries() {
        return AddressUtils.isoCountries();
    }

      async getAddressData(addressData: any, placeData: any) {
      this.vm.buildingNameNumber = addressData.street_number ? addressData.street_number:'';
      this.vm.streetRoadBlock = addressData.route ? addressData.route:'';
      this.vm.locality = addressData.locality ? addressData.locality:'';
      //Pick out the postal town
      for (let index = 0; index < placeData.address_components.length; index++) {
        const element = placeData.address_components[index];
        if (element.types[0] === "postal_town"){
          this.vm.cityTown = element.long_name;
        }
        
      }
      //Pick out the country code
      for (let index = 0; index < placeData.address_components.length; index++) {
        const element = placeData.address_components[index];
        const isoCountriesLocal = this.isoCountries;
        if (element.types[0] === "country"){
          for (let countryIndex = 0; countryIndex < isoCountriesLocal.length; countryIndex++) {
            if (isoCountriesLocal[countryIndex].code === element.short_name) {
              this.vm.country = isoCountriesLocal[countryIndex];
            }
          }
        }   
      }
      //this.entity.address.countryCode = 'GB';
      this.vm.stateProvinceRegion = addressData.administrative_area_level_2 ? addressData.administrative_area_level_2:'';
      this.vm.postZipCode = addressData.postal_code ? addressData.postal_code:'';
      this.vm.geometry.lat = addressData.latitude;
      this.vm.geometry.lng = addressData.longitude;
  }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        this.vm.jobWorkerId = this.jobWorker.id;
        await JobDetailsModule.createJobWorkerInterview(this.vm);
        this.dialog = false;
    }
}
